/*
 *   File : update-rm.js
 *   Author URI : https://evoqins.com
 *   Description :  To link a customer account against a Relationship Manager.
 *   Integrations : null
 *   Version : v1.1
 */


import { useEffect } from "react";

import { Icon } from "../Icon";
import { GradientButton } from "../Cta";

import style from "../../Styles/Components/update-rm.module.scss";
import { closeModal } from "../../Helper/helper-function";

const SuccessModal = (props) => {


    useEffect(() => {
        var my_modal = document.getElementById("success-modal");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.handleClose();
        });
    }, []);

    const _handleBack = () => {
        closeModal("success-modal");
        props.handleBack();
    };

    return (
        <div className={`modal fade ${style.e_update_rm}`}
            id="success-modal"
            tabIndex="-1"
            aria-labelledby="success-modal"
            aria-hidden="true"
            data-bs-backdrop="true" >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content bg-white  padding-32px-all ${style.e_content} `}>
                    <div className="d-flex justify-content-end align-items-center mb-3">
                        {/* <p className="e-poppins-medium e-font-18 line-height-16px mb-0">Preview</p> */}
                        <Icon icon="close"
                            size={24}
                            data-bs-dismiss="modal"
                            className="cursor-pointer e-modal-close-btn" />
                    </div>
                    <>



                        <div className="text-center ">
                            <div className="pb-3">
                                <img src={require('../../Assets/Images/White-Label-Settings/success-icon.png')} width={72} height={72} alt="" />
                            </div>
                            <h3 className="e-poppins-medium e-font-18 color-eerie-black mb-2">White label settings added</h3>
                            <h6 className="e-poppins-regular e-font-14  color-outer-space mb-0">Successfully configured.</h6>
                        </div>


                        <div className="d-flex align-items-center justify-content-center gap-8px margin-32px-top w-100 ">
                            <GradientButton label="Back"
                                className="padding-12px-tb e-font-16  "
                                // loading={apiLoader}
                                onPress={_handleBack} />
                        </div>
                    </>


                </div>
            </div>
        </div>
    )
}

export default SuccessModal;